export default __webpack_public_path__ + "static/media/mascoteAurea3.a301229a.png";